<template>
  <ContentWrap title="预订订单管理">
    <!-- 搜索区域 -->
    <el-form :model="queryParams" ref="queryFormRef" :inline="true" class="search-form">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="店铺" prop="shopId">
            <el-select
              v-model="queryParams.shopId"
              placeholder="请选择店铺"
              clearable
              style="width: 100%"
            >
              <el-option
                v-for="item in shopList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="订单号" prop="orderNo">
            <el-input
              v-model="queryParams.orderNo"
              placeholder="请输入订单号"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="订单状态" prop="status">
            <el-select
              v-model="queryParams.status"
              placeholder="请选择状态"
              clearable
              style="width: 100%"
            >
              <el-option label="待支付" :value="0" />
              <el-option label="已支付" :value="1" />
              <el-option label="已确认" :value="2" />
              <el-option label="已入住" :value="3" />
              <el-option label="已完成" :value="4" />
              <el-option label="已取消" :value="5" />
              <el-option label="未到店" :value="6" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="入住人" prop="guestName">
            <el-input
              v-model="queryParams.guestName"
              placeholder="请输入入住人姓名"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="入住日期" prop="checkInDateRange">
            <el-date-picker
              v-model="queryParams.checkInDateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="YYYY-MM-DD"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="创建时间" prop="createTimeRange">
            <el-date-picker
              v-model="queryParams.createTimeRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="YYYY-MM-DD"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item>
            <el-button type="primary" @click="handleQuery">
              <el-icon><Search /></el-icon>
              搜索
            </el-button>
            <el-button @click="resetQuery">
              <el-icon><Refresh /></el-icon>
              重置
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <!-- 表格区域 -->
    <div class="table-header">
      <span class="table-title">订单列表</span>
    </div>

    <el-table v-loading="loading" :data="list" border stripe>
      <el-table-column label="订单号" prop="orderNo" min-width="180" show-overflow-tooltip />
      <el-table-column label="店铺" prop="shopName" min-width="120" show-overflow-tooltip />
      <el-table-column label="房型" prop="spuName" min-width="120" show-overflow-tooltip />
      <el-table-column label="房间号" prop="roomNo" min-width="100" />
      <el-table-column label="入住人" prop="guestName" min-width="100" />
      <el-table-column label="入住日期" prop="checkInDate" min-width="110" />
      <el-table-column label="退房日期" prop="checkOutDate" min-width="110" />
      <el-table-column label="金额" prop="payAmount" min-width="100" align="right">
        <template #default="scope">
          <span class="amount-text">¥{{ scope.row.payAmount?.toFixed(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="押金" min-width="120"><template #default="s">¥{{ Number(s.row.depositAmount || 0).toFixed(2) }} / {{ ['未收','已收','已退','扣除'][s.row.depositStatus || 0] }}</template></el-table-column>
      <el-table-column label="退款" min-width="90"><template #default="s">{{ ['未退款','部分','全额'][s.row.refundStatus || 0] }}</template></el-table-column>
      <el-table-column label="状态" prop="status" min-width="90" align="center">
        <template #default="scope">
          <el-tag :type="getStatusTagType(scope.row.status)">
            {{ getStatusLabel(scope.row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="createTime" min-width="160" />
      <el-table-column label="操作" min-width="220" fixed="right" align="center">
        <template #default="scope">
          <el-button link type="primary" @click="guestDrawerRef?.open(scope.row.id)">入住人</el-button>
          <el-dropdown @command="(cmd) => openFinance(cmd, scope.row)"><el-button link type="primary">资金</el-button><template #dropdown><el-dropdown-menu><el-dropdown-item command="collect">收押金</el-dropdown-item><el-dropdown-item command="deposit-refund">退押金</el-dropdown-item><el-dropdown-item command="refund">订单退款</el-dropdown-item></el-dropdown-menu></template></el-dropdown>
          <el-button
            v-if="scope.row.status === 0 || scope.row.status === 1"
            link
            type="success"
            v-hasPermi="['hotel:booking-order:confirm']"
            @click="handleConfirm(scope.row)"
          >
            确认
          </el-button>
          <el-button
            v-if="scope.row.status === 2"
            link
            type="primary"
            v-hasPermi="['hotel:booking-order:check-in']"
            @click="handleCheckIn(scope.row)"
          >
            入住
          </el-button>
          <el-button
            v-if="scope.row.status === 3"
            link
            type="warning"
            v-hasPermi="['hotel:booking-order:check-out']"
            @click="handleCheckOut(scope.row)"
          >
            退房
          </el-button>
          <el-button
            v-if="scope.row.status !== 4 && scope.row.status !== 5"
            link
            type="danger"
            v-hasPermi="['hotel:booking-order:cancel', 'hotel:platform:order:cancel']"
            @click="handleCancel(scope.row)"
          >
            取消
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <Pagination
      v-model:page="queryParams.pageNo"
      v-model:limit="queryParams.pageSize"
      :total="total"
      @pagination="getList"
    />

    <!-- 取消订单弹窗 -->
    <el-dialog
      v-model="cancelDialogVisible"
      title="取消订单"
      width="450px"
      :close-on-click-modal="false"
    >
      <el-form :model="cancelForm" label-width="80px">
        <el-form-item>
          <span class="cancel-tip">确认取消订单 <strong>{{ currentCancelOrder?.orderNo }}</strong> 吗？</span>
        </el-form-item>
        <el-form-item label="取消原因" prop="cancelReason">
          <el-input
            v-model="cancelForm.cancelReason"
            type="textarea"
            :rows="3"
            placeholder="请输入取消原因"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="cancelDialogVisible = false">关闭</el-button>
        <el-button type="danger" @click="confirmCancel" :loading="cancelLoading">
          确认取消
        </el-button>
      </template>
    </el-dialog>
    <GuestDrawer ref="guestDrawerRef" />
    <Dialog v-model="financeVisible" :title="financeTitles[financeType]" width="450px"><el-form label-width="90px"><el-form-item label="金额"><el-input-number v-model="financeForm.amount" :min="0.01" :precision="2" /></el-form-item><el-form-item v-if="financeType !== 'collect'" label="原因"><el-input v-model="financeForm.reason" type="textarea" /></el-form-item></el-form><template #footer><el-button @click="financeVisible=false">取消</el-button><el-button type="primary" @click="submitFinance">确认</el-button></template></Dialog>
  </ContentWrap>
</template>

<script setup lang="ts">
import { ref, reactive, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { Search, Refresh } from '@element-plus/icons-vue'
import { getShopSimpleList } from '@/api/hotel/platformShop'
import * as BookingOrderApi from '@/api/hotel/bookingOrder'
import type { BookingOrderVO } from '@/api/hotel/bookingOrder'
import GuestDrawer from './GuestDrawer.vue'

defineOptions({ name: 'HotelBookingOrder' })
const guestDrawerRef = ref<InstanceType<typeof GuestDrawer>>()
const financeVisible=ref(false),financeType=ref('collect'),financeOrder=ref<BookingOrderVO>();const financeForm=reactive({amount:0,reason:''});const financeTitles:Record<string,string>={collect:'收取押金','deposit-refund':'退还押金',refund:'订单退款'}
const openFinance=(type:string,row:BookingOrderVO)=>{financeType.value=type;financeOrder.value=row;financeForm.amount=type==='collect'?Number(row.depositAmount||0):type==='deposit-refund'?Number(row.depositAmount||0):Number(row.payAmount||0)-Number(row.refundAmount||0);financeForm.reason='';financeVisible.value=true}
const submitFinance=async()=>{const id=financeOrder.value!.id;if(financeType.value==='collect')await BookingOrderApi.collectDeposit(id,financeForm.amount);else if(financeType.value==='deposit-refund')await BookingOrderApi.refundDeposit(id,financeForm.amount,financeForm.reason);else{await ElMessageBox.confirm('退款会影响订单、库存和结算，确认继续？','确认退款',{type:'warning'});await BookingOrderApi.refund(id,financeForm.amount,financeForm.reason)}ElMessage.success('操作成功');financeVisible.value=false;getList()}

// ==================== 状态映射 ====================
const statusMap: Record<number, { label: string; type: string }> = {
  0: { label: '待支付', type: 'info' },
  1: { label: '已支付', type: 'warning' },
  2: { label: '已确认', type: 'success' },
  3: { label: '已入住', type: 'primary' },
  4: { label: '已完成', type: '' },
  5: { label: '已取消', type: 'danger' },
  6: { label: '未到店', type: 'warning' }
}

const getStatusLabel = (status: number): string => {
  return statusMap[status]?.label || '未知'
}

const getStatusTagType = (status: number): string => {
  return statusMap[status]?.type || 'info'
}

// ==================== 搜索相关 ====================
const queryFormRef = ref()
const loading = ref(false)
const total = ref(0)
const list = ref<BookingOrderVO[]>([])
const shopList = ref<any[]>([])

const queryParams = reactive({
  pageNo: 1,
  pageSize: 10,
  shopId: undefined as string | number | undefined,
  orderNo: '',
  status: undefined as number | undefined,
  guestName: '',
  checkInDateRange: [] as string[],
  createTimeRange: [] as string[]
})

// ==================== 取消订单相关 ====================
const cancelDialogVisible = ref(false)
const cancelLoading = ref(false)
const currentCancelOrder = ref<BookingOrderVO | null>(null)

const cancelForm = reactive({
  cancelReason: ''
})

// ==================== 数据加载 ====================
const getList = async () => {
  loading.value = true
  try {
    const params: any = {
      pageNo: queryParams.pageNo,
      pageSize: queryParams.pageSize
    }
    if (queryParams.shopId) {
      params.shopId = queryParams.shopId
    }
    if (queryParams.orderNo?.trim()) {
      params.orderNo = queryParams.orderNo.trim()
    }
    if (queryParams.guestName?.trim()) {
      params.guestName = queryParams.guestName.trim()
    }
    if (queryParams.status !== undefined && queryParams.status !== null) {
      params.status = queryParams.status
    }
    if (queryParams.checkInDateRange && queryParams.checkInDateRange.length === 2) {
      params.beginCheckInDate = queryParams.checkInDateRange[0]
      params.endCheckInDate = queryParams.checkInDateRange[1]
    }
    if (queryParams.createTimeRange && queryParams.createTimeRange.length === 2) {
      params.beginCreateTime = `${queryParams.createTimeRange[0]} 00:00:00`
      params.endCreateTime = `${queryParams.createTimeRange[1]} 23:59:59`
    }
    const res = await BookingOrderApi.getBookingOrderPage(params)
    list.value = res.list || []
    total.value = res.total || 0
  } catch {
    // ignore
  } finally {
    loading.value = false
  }
}

const loadShopList = async () => {
  try {
    const res = await getShopSimpleList()
    shopList.value = res || []
  } catch {
    // ignore
  }
}

// ==================== 搜索操作 ====================
const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}

const resetQuery = () => {
  queryFormRef.value?.resetFields()
  queryParams.pageNo = 1
  queryParams.shopId = undefined
  queryParams.orderNo = ''
  queryParams.status = undefined
  queryParams.guestName = ''
  queryParams.checkInDateRange = []
  queryParams.createTimeRange = []
  getList()
}

// ==================== 确认订单 ====================
const handleConfirm = (row: BookingOrderVO) => {
  ElMessageBox.confirm(
    `确认将订单 <strong>${row.orderNo}</strong> 标记为已确认？`,
    '确认订单',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
      dangerouslyUseHTMLString: true
    }
  ).then(async () => {
    try {
      await BookingOrderApi.confirmBookingOrder(row.id!)
      ElMessage.success('订单确认成功')
      getList()
    } catch {
      // ignore
    }
  }).catch(() => {
    // cancel
  })
}

// ==================== 取消订单 ====================
const handleCancel = (row: BookingOrderVO) => {
  currentCancelOrder.value = row
  cancelForm.cancelReason = ''
  cancelDialogVisible.value = true
}

const confirmCancel = async () => {
  if (!currentCancelOrder.value) return
  cancelLoading.value = true
  try {
    await BookingOrderApi.cancelBookingOrder(
      currentCancelOrder.value.id!,
      cancelForm.cancelReason
    )
    ElMessage.success('订单取消成功')
    cancelDialogVisible.value = false
    getList()
  } catch {
    // ignore
  } finally {
    cancelLoading.value = false
  }
}

// ==================== 入住 ====================
const handleCheckIn = (row: BookingOrderVO) => {
  ElMessageBox.confirm(
    `确认订单 <strong>${row.orderNo}</strong> 办理入住？`,
    '入住登记',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
      dangerouslyUseHTMLString: true
    }
  ).then(async () => {
    try {
      await BookingOrderApi.checkIn(row.id!)
      ElMessage.success('入住登记成功')
      getList()
    } catch {
      // ignore
    }
  }).catch(() => {
    // cancel
  })
}

// ==================== 退房 ====================
const handleCheckOut = (row: BookingOrderVO) => {
  ElMessageBox.confirm(
    `确认订单 <strong>${row.orderNo}</strong> 办理退房？`,
    '退房确认',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
      dangerouslyUseHTMLString: true
    }
  ).then(async () => {
    try {
      await BookingOrderApi.checkOut(row.id!)
      ElMessage.success('退房成功')
      getList()
    } catch {
      // ignore
    }
  }).catch(() => {
    // cancel
  })
}

// ==================== 初始化 ====================
onMounted(() => {
  loadShopList()
  getList()
})
</script>

<style scoped lang="scss">
.search-form {
  margin-bottom: 16px;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;

  .table-title {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
  }
}

.amount-text {
  color: #f56c6c;
  font-weight: 500;
}

.cancel-tip {
  font-size: 14px;
  color: #606266;
  line-height: 32px;
}
</style>
